import script from "./project-delete-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./project-delete-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__